export default {
    General: 'Të përgjithshme',
    'Tax Number': 'Numri ID',
    'Display Name': 'Emri i plotë',
    Phone: 'Telefon',
    Email: 'Email',
    'Phone Number': 'Numri i telefonit',
    Agency: 'Agjencia',
    Code: 'Kodi',
    'AMF Code': 'Kodi AMF',
    'AMF Username': 'Emri i përdoruesit AMF',
    'AMF Password': 'Fjalëkalimi AMF',
    System: 'Sistemi',
    'Created On': 'Krijuar më',
    'System Entity': 'Enti i sistemit',
    Actions: 'Veprimet',
    'Balance LCY': 'Bilanci LCY',
    'Due Balance LCY': 'Due Balance LCY',
    Marine: 'Marina',
    'Commission to Month': 'Komisioni në muaj',
    Serial: 'Seriali',
    'Insurance Sector Type': 'Lloji i Sektorit të Sigurimeve',
    'Issued Date': 'Data e lëshimit',
    'Start Date': 'Data e fillimit',
    'From the date': 'Nga data',
    'Until the date': 'Deri datën',
    'Prime aggregation only for active police': 'Agregim primesh vetem per policat aktive',
    'Primes for each department': 'Primet per cdo departament',
    'The client has no prime in the system!': 'Klienti nuk ka prime në sistem!',
    'Status Type': 'Lloji i statusit',
    'Premium Gross': 'Primi Bruto',
    'Premium Net': 'Primi Neto',
    Underwriter: 'Nënshkrues',
    Intermediary: 'Ndërmjetës',
    'Product Code': 'Kodi i produktit',
    'Product Name': 'Emri i produktit',
    Currency: 'Valuta',
    'Agency Commission Rate': 'Norma e komisionit të agjencisë',
    Agent: 'Agjent',
    'Bonus Commission Rate': 'Norma e komisionit të bonusit',
    Leader: 'Lider',
    Customer: 'Klient',
    'Owner %': 'Përqindja e pronësisë %',
    'Invoice %': 'Faturë %',
    Name: 'Emri',
    'Contact Type': 'Lloji i kontaktit',
    Checked: 'Kontrolluar',
    Coverage: 'Mbulimi',
    Mandatory: 'I detyrueshëm',
    Premium: 'Premium',
    'Sum Insured': 'Shuma e siguruar',
    'The Deductible Part': 'Pjesa e zbritshme',
    Franchize: 'Franshiza',
    'Event Based Limits': 'Kufijtë e bazuar në ngjarje',
    'Person Based Limits': 'Kufijtë e bazuar në persona',
    'Period Based Limits': 'Kufijtë e bazuar në periudhë',
    'Special Coverage': 'Mbulim i veçantë',
    Local: 'Lokal',
    Country: 'Vendi',
    City: 'Qyteti',
    'Postal Code': 'Kodi Postar',
    'Street Address': 'Adresa e rrugës',
    'Street Address 2': 'Adresa e rrugës 2',
    'Insured Amount': 'Shuma e siguruar',
    Id: 'ID',
    Comment: 'Koment',
    Date: 'Data',
    'Created By': 'Krijuar nga',
    'Total Limit': 'Limiti total',
    Order: 'Radha',
    Amount: 'Vlera',
    Description: 'Përshkrim',
    'Nr.': 'Nr.',
    'End Date': 'Data e përfundimit',
    'Customer Name': 'Emri i Klientit',
    'Owner Name': 'Emri i Pronarit',
    'Permit Number': 'Numri i lejes',
    Vehicle: 'Automjet',
    Vin: 'Shasia',
    Plate: 'Targa',
    Classification: 'Klasifikimi',
    Make: 'Marka',
    Model: 'Model',
    Power: 'Fuqia',
    Region: 'Rajon',
    Fuel: 'Karburant',
    Year: 'Viti',
    Type: 'Lloji',
    Volume: 'Vëllimi',
    Seats: 'Vende',
    Color: 'Ngjyra',
    Obligations: 'Detyrime',
    'We to the customer': 'Ne për klientin',
    'The customer to us': 'Klienti tek ne',
    Details: 'Detajet',
    Birthday: 'Ditëlindja',
    Hospital: 'Spitali',
    Website: 'Website',
    Notes: 'Shënime',
    'Hospital Type': 'Lloji i spitalit',
    'Tax Rate': 'Norma e tatimit',
    Commissions: 'Komisionet',
    'Agent Commission Rate': 'Norma e komisionit të agjentit',
    'Bonus Commission Rate Cap': 'Kapi i normës së komisionit të bonusit',
    'AMF Contribution Rate': 'Norma e kontributit të AMF',
    'Dynamic Durations': 'Kohëzgjatjet dinamike',
    Group: 'Grupi',
    Default: 'E parazgjedhur',
    Years: 'Vite',
    Months: 'Muaj',
    Days: 'Ditë',
    'Stock Id': 'Id i aksioneve',
    'Serial Start': 'Fillimi i serialit',
    'Serial End': 'Fundi serial',
    'Total Serials': 'Serialet totale',
    'Customer Policies': 'Policat e klientit',
    'Agency Policies': 'Policat e Agjencisë',
    'Agent Policies': 'Policat e agjentëve',
    'All Policies': 'Të gjitha policat',
    'Draft Policies': 'Policat draft',
    'Issued Policies': 'Policat e leshuara',
    'Archived Policies': 'Policat e arkivuara',
    Motor: 'Motor',
    Quantity: 'Sasia',
    Branch: 'Dega',
    Summary: 'Përmbledhje',
    Generals: 'Gjeneralët',
    'Base Coverage': 'Mbulimi bazë',
    'First Coverage': 'Mbulimi i pare',
    'Second Coverage': 'Mbulimi i dyte',
    'Third Coverage': 'Mbulimi i trete',
    'Fourth Coverage': 'Mbulimi i katert',
    Number: 'Numri',
    Property: 'Prone',
    'Selected Coverages': 'Mbulime të selektuara',
    'Selected Articles': 'Artikuj të selektuar',
    'Article Type': 'Tipi i artikullit',
    'Numri i policave te shitura': 'Numri i policave te shitura',
    'Primet totale - ALL': 'Primet totale - ALL',
    'Primet totale - EUR': 'Primet totale - EUR',
    'Open Details': 'Shiko Detajet',
    'Open Risk Addresses': 'Shiko adresat e rrezikut',
    'Fill Form': 'Plotësoni formularin',
    'Open Agencies': 'Shiko Agjencitë',
    'UXH Status': 'UXH Status',
    'Policy Agent': 'Agjent police',
    'Sales Agent': 'Agjent shitje',
    'Identifier 1': 'Identifikuesi 1',
    'Identifier 2': 'Identifikuesi 2',
    'Identifier 3': 'Identifikuesi 3',
    'Min Premium': 'Primi minimal',
    'Blocked Type': 'Lloji i bllokimit',
    'Iosa Id': 'Iosa Id',
    '...': '...',
    'Cancellation Reason': 'Arsyeja e anulimit',
    'Cancelled By': 'Anuluar Nga',
    Global: 'Globale',
    Duplicate: 'Dublikate',
    'Premium Adjustment': 'Axhustim primi',
    'Bank Transaction Id': 'ID e transaksionit bankar',
    'AMF Report Code': 'Kodi i raportit të AMF',
    'The Insured': 'I Siguruari ',
    'The Insured (Tax Number)': 'I Siguruari  (ID)',
    'Related Agency Code': 'Kodi i agjencisë së lidhur',
    'Agency Code': 'Kodi i Agjencisë',
    'Premium Calculated': 'Primi i llogaritur',
    'Maximum Coverage Amount': 'Maksimumi i mbulimit',
    'Insured Object': 'Objekt i siguruar',
    'List of insured objects': 'Lista e objekteve të siguruara',
    'Risk Address': 'Adresa e rrezikut',
    'Cancellation Date': 'Data e anullimit',
    Client: 'Klienti',
    Renewals: 'Rinovime / Keste',
    Identifier: 'Identifikues',
    Citizenship: 'Shtetësia',
    'Installment Date': 'Data e këstit',
    'Number of installments': 'Numri i kësteve',
    Installments: 'Këstet',
    'Insured Sum': 'Shuma e siguruar',
    'Number of renewals': 'Numri i rinovimeve',
    Driver: 'Shofer',
    Role: 'Roli',
    'Policy User': 'Përdoruesi i policës',
    'Extra Fee': 'Tarifa shtesë',
    'Risk Addresses': 'Adresat e rrezikut',
    AccountType: 'Tipi i Llogarise',
    Account: 'Llogaria',
    SystemDescription: 'Përshkrimi nga Sistemi',
    AccountMonetary: 'Mon. Llogarise',
    Balance: 'Balanca',
    ExchangeRate: 'Kursi Dok.',
    BalanceLCY: 'Balanca ALL',
    DebitValue: 'Vlera Debi',
    CreditValue: 'Vlera Kredi',
    Value: 'Vlera',
    ValueLCY: 'Vlera ALL',
    NewBalance: 'Balanca e re',
    NewBalanceLCY: 'Balanca e re ALL',
    Note: 'Përshkrim nga Sistemi',
    'Nr. ERP': 'Nr. ERP',
    'Nr. Serial Polica': 'Nr. Serial Polica',
    'Dt. Fatures': 'Dt. Faturës',
    'Dt. Krijimi Fatures': 'Dt. Krijimi Faturës',
    'Klient Tax Id': 'Klient Tax Id',
    'Klient Lloji': 'Klient Lloji',
    'Klient Emri': 'Klient Emri',
    'No.': 'Nr.',
    Pershkrim: 'Përshkrim',
    Monedha: 'Monedha',
    Kursi: 'Kursi',
    Vlera: 'Vlera',
    'Vlera ALL': 'Vlera ALL',
    FISKALIZUAR: 'FISKALIZUAR',
    Invoices: 'Faturat',
    'Start Date Range': 'Intervali i datës së fillimit',
    'Issue Date Range': 'Intervali i datës së lëshimit',
    'Dates Configurations': 'Konfigurimet e datave',
    'Can Sell': 'Shitje',
    'Can Cancel': 'Anulim',
    'Can Return': 'Kthim',
    'Can Duplicate': 'Dublikate',
    'Can Adjust Premium': 'Modifikim primi',
    'Has Installments': 'Këste',
    'Has Renewals': 'Rinovime',
    Beneficiaries: 'Përfituesit ',
    'Policy Holders': 'Mbajtësit e policës',
    'Policy Users': 'Përdoruesit e policës',
    'Invoice Recipient': 'Marrësit e faturës',
    Participants: 'Pjesëmarrësit',
    'Types Allowed': 'Llojet e lejuara',
    'The reason for the failure': 'Arsyeja e dështimit',
    'The number of bank branches': 'Numri i degëve të bankës',
    'Modifikim fature': 'Modifikim fature',
    'Ndrysho faturimin': 'Ndrysho faturimin',
    'Insurer Display Name': 'Emri i siguruesit',
    'Territorial Coverage': 'Mbulimi Territorial',
    'Dt. Fillimit': 'Dt. Fillimit',
    'Dt. Mbarimit': 'Dt. Mbarimit',
    'Product Template': 'Paketa e produktit',
    'Beneficiary Display Name': 'Emri i përfituesit',
    'Beneficiary Tax Number': 'ID e përfituesit',
    'Beneficiary Display Name 2': 'Emri i përfituesit 2',
    'Beneficiary Tax Number 2': 'ID e përfituesit 2',
    'PolicyHolder Display Name': 'Emri i police mbajtësit',
    'PolicyHolder Tax Number': 'ID e police mbajtësit',
    'Coverage Display Name List': 'Emri i mbulimit',
    Sublimits: 'Sherbimet',
    Rates: 'Normat',
    'Select product': 'Zgjidh produktin',
    'Select product & template': 'Zgjidh paketen e produktit ',
    'Select agency': 'Zgjidh agjencinë',
    'Work status': 'Statusi i punes',
    Roles: 'Rolet',
    Koeficenti: 'Koeficenti',
    'Data e praktikes': 'Data e praktikes',
    'Data e njoftimit': 'Data e njoftimit',
    'Lloji i demit': 'Lloji i demit',
    'Total Value': 'Total Value',
    Card: 'Karta',
    'Status Updated By': 'Statusi i përditësuar nga',
    'Status Updated Date': 'Data e përditësimit të statusit',
    'Status Updated Reason': 'Arsyeja e përditësimit të statusit',
    'Custom Limit': 'Custom Limit',
    Billed: 'Faturuar',
    Pay: 'Paguar',
    Debit: 'Debit',
    'Agency Name': 'Emri i Agjencisë',
    Comments: 'Komentet',
    'Sub Services': 'Sub Services',
    'Nen sherbimet': 'Nen sherbimet',
    'Number of Insured Objects': 'Numri i objekteve të siguruara',
    'Lloji i personit': 'Lloji i personit',
    'Paid Amount LCY': 'Vlera e paguar ALL',
    'Paid Amount': 'Vlera e paguar',
    Select: 'Selekto',
    'Min Start Date Range': 'Intervali minimal i datës së fillimit',
    'Max Start Date Range': 'Intervali maksimal i datës së fillimit',
    'Min Issue Date Range': 'Intervali minimal i datës së lëshimit',
    'Max Issue Date Range': 'Intervali maksimal i datës së lëshimit',
    'Min Beneficiary': 'Numri minimal i përfituesit',
    'Max Beneficiary': 'Numri maksimal i përfituesit',
    'Min Policy Holder': 'Numri min i mbajtësve të policës',
    'Max Policy Holder': 'Numri max i mbajtësve të policës',
    'Max Policy User': 'Numri max i përdoruesëve të policës',
    'Min Policy User': 'Numri min i përdoruesëve të policës',
    'Min Insurer': 'Numri min i të siguruarve',
    'Max Insurer': 'Numri max i të siguruarve',
    'Min Invoice Recipient': 'Numri min i marrësit të faturës',
    'Max Invoice Recipient': 'Numri max i marrësit të faturës',
    'Search Agency': 'Kerko agjencinë',
    'Search Customer': 'Kerko klientin',
    'Search Policy Serial': 'Kerko policën me serial',
    'Projected Total': 'Totali i parashikuar',
    'Selekto pagesen per editim': 'Selekto pagesen per editim',
    'Fisc UblId': 'Fisc UblId',
    'Posted On': 'Postuar më',
    'Amount LCY': 'Vlera ALL',
    'Can Edit Template': 'Editon paketen',
    'Payable Within': 'Afati i pagesës',
    'Continuity Date': 'Data e vazhdueshmërisë',
    'Action Type': 'Lloji i veprimit',
    'Status Note': 'Pershkrimi i statusit',
    Source: 'Burimi',
    'IOSA ID': 'IOSA ID',
    'Created At': 'Data e Krijimit',
    'Updated At': 'Data e Përditësimit',
    'Updated By': 'Përditësuar nga',
    'Policy Serial': 'Seriali i Polices',
    Paid: 'Paguar',
    Nr: 'Nr',
    'Loading Date': 'Data e ngarkimit',
    Sender: 'Derguesi',
    'Sender NUIS': 'NUIS i derguesit',
    Receiver: 'Marresi',
    'Receiver NUIS': 'NUIS i marresit',
    'Cargo Description': 'Pershkrimi i mallit',
    Weight: 'Pesha',
    'Vehicle Plate': 'Targa e mjetit',
    'Trailer Plate': 'Targa e rimorkios',
    'Loading Country': 'Shteti i ngarkimit',
    'Loading City': 'Qyteti i ngarkimit',
    'Loading Address': 'Adresa e ngarkimit',
    'Delivery Country': 'Shteti i dorezimit',
    'Delivery City': 'Qyteti i dorezimit',
    'Delivery Address': 'Adresa e dorezimit',

    'Channel Type': 'Lloji i kanalit',
    'Scope Type': 'Lloji i shtrirjes',
    'Normalized Value': 'Vlera e normalizuar',
    Active: 'Aktiv',
    Reason: 'Arsyeja',
    'Related Policies': 'Polica të lidhura',
    'Cross Sell': 'Shitje e kombinuar',
    'Cross Sell / Inherited Participants': 'Shitje e kombinuar / Trashëgimi i pjesëmarrësve',
    'Coverage Period': 'Periudha e mbulimit',
    Version: 'Version',
};
